import { render, staticRenderFns } from "./I.vue?vue&type=template&id=12cc3d91&scoped=true&"
import script from "./I.vue?vue&type=script&lang=js&"
export * from "./I.vue?vue&type=script&lang=js&"
import style0 from "./I.vue?vue&type=style&index=0&id=12cc3d91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc3d91",
  null
  
)

export default component.exports